var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('dashboard-info-block'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"flex xs12"},[_c('dashboard-table')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }